module.exports = "/images/TXR Preview_pages-3.jpg?db7b1ec3613e3b9dce27726a7a44421a";